import { extend } from "jquery";
import { ReceiptsInfo } from "../claimant-on-web/claimant-on-web";
import { DocumentDetails } from "../DutyofCare/dutyofcare";
import { IEmployeeListForAssignedGrade } from "../grade/grade";
import { IApproverNotes, IReceiptInfo } from "../twostepapproval/claimant-expense-detail";

export interface IResponseVendorSettings {
    isKYCMandatoryForInvoice: boolean;
    isKYCFormSetting: number;
}

export class ResponseVendorSettings implements IResponseVendorSettings {
    isKYCMandatoryForInvoice: boolean;
    isKYCFormSetting: number;
}

export class ReqIncompleteClaimantList {
    orgId: number;
    userId: number;
}

export class RespIncompleteMileageList {
    expenseIds: number[];
}

export interface IReqSaveVendorSettings {
    isKYCFormSetting: boolean;
    isKYCMandatoryForInvoice: boolean;
    orgId: number;
}

export class ReqSaveVendorSettings implements IReqSaveVendorSettings {
    isKYCFormSetting: boolean;
    isKYCMandatoryForInvoice: boolean;
    orgId: number;
}

export class RespMasterFormFields {
    lstMasterFormFields: MasterFormFields[];
}

export class MasterFormFields {
    formFieldID: number;
    masterFormFieldID: number;
    setupName: string;
    displayName: string;
    active: boolean;
    type: number;
    typeName: string;
    countofCharacters: number;
    textFormat: number;
    allowSpecialCharacters: boolean;
    dateFormat: number;
    imgAlignment: number;
    notesCharacterCount: number;
    defaultOptionsCount: number;
    maxOptionCount: number;
    maxDropdownListCount: number;
    uuId: string;
}

export class RespForms {
    lstForms: VendorForm[];
    lstFormFields: FormFields[];
}

export class VendorForm {
    formID: number;
    formName: string;
    isArchived: boolean;
    countOfVendors: number;
    orgId: number;
    flag: number;
    formType: number;
}

export class FormFields {
    formFieldID: number;
    masterFormFieldID: number;
    setupName: string;
    displayName: string;
    active: boolean;
    type: number;
    typeName: string;
    countofCharacters: number;
    textFormat: number;
    allowSpecialCharacters: boolean;
    dateFormat: number;
    imgAlignment: number;
    notesCharacterCount: number;
    formID: number;
    uuId: string;
    highlight: boolean;
    lstFormRadioOptions: FormRadioOptions[];
    lstFormDropdownOptions: FormDropdownOptions[];
    hasFormChanges: boolean;
    isDisplayOnPoNumber: boolean;
    isDisplayOnPO: boolean;
    isDefault: boolean;
    poSequence: number;
    srNo: number;
}

export class FormRadioOptions {
    formRODetailsId: number;
    uuId: string;
    formFieldID: number;
    displayName: string;
    addVisible: boolean;
    flag: boolean;
}

export class FormDropdownOptions {
    formDDDetailsId: number;
    formFieldID: number;
    uuId: string;
    displayName: string;
    flag: boolean;
}

export class ReqSaveVendorForms {
    vendorFormDetails: VendorForm;
    lstFormFields: FormFields[];
    userId: number;
    vendorFormArea: number;
}

export class RespGetKYCDocumentsForApproval {
    lstKYCDocumentDetails: KYCDocumentDetailsForApproval[];
}

export class KYCDocumentDetailsForApproval {
    userOrgMappingId: number;
    displayName: string;
    email: string;
    documentCount: number;
    status: number;
    approverName: string;
    approvalDate: number;
    userId: number;
    orgId: number;
    lstVendorKYCDocuments: VendorKYCDocuments[];
    lstVendorKYCDocumentFieldDetails: VendorKYCDocumentFieldDetails[];
}

export class ResponseVendorKYCDocuments {
    lstVendorKYCDocuments: VendorKYCDocuments[];
    lstVendorKYCDocumentFieldDetails: VendorKYCDocumentFieldDetails[];
}

export class VendorKYCDocuments {
    userKYCFormMappingId: number;
    userId: number;
    orgId: number;
    formId: number;
    formName: string;
    status: number;
    hideRecall: boolean;
    hideEdit: boolean;
    comments: string;
}

export class VendorKYCDocumentFieldDetails {
    userKYCFormFieldDetailsID: number;
    formFieldID: number;
    masterFormFieldID: number;
    setupName: string;
    displayName: string;
    active: boolean;
    type: number;
    typeName: string;
    countofCharacters: number;
    textFormat: number;
    allowSpecialCharacters: boolean;
    dateFormat: number;
    imgAlignment: number;
    notesCharacterCount: number;
    formID: number;
    formFieldValue: number;
    value: string = '';
    isDefault: boolean;
    lstFormRadioOptions: FormRadioOptions[];
    lstFormDropdownOptions: FormDropdownOptions[];
    documentDetails: DocumentDetails[];
}

export interface ISaveRequestWithFile {
    requestData: string;
    documents: File[];
    content: any;
}

export class SaveRequestWithFile implements ISaveRequestWithFile {
    requestData: string;
    documents: File[];
    content: any;
    constructor(
        requestData: string,
        documents: File[],
        content: any

    ) {
        this.requestData = requestData;
        this.documents = documents;
        this.content = content;
    }
}

export interface IFormStatus {
    userKYCFormMappingId: number;
    formID: number;
    status: number;
}

export class FormStatus implements IFormStatus {
    userKYCFormMappingId: number;
    formID: number;
    status: number;
    constructor(
        userKYCFormMappingId: number,
        formID: number,
        status: number
    ) {
        this.userKYCFormMappingId = userKYCFormMappingId;
        this.formID = formID;
        this.status = status;
    }
}

export interface IFormsUpdateRequest {
    userID: number;
    formStatus: FormStatus[];
    actionBy: number;
    actionOn: number;
    approverComments: string;
}

export class FormsUpdateRequest implements IFormsUpdateRequest {
    userID: number;
    formStatus: FormStatus[];
    actionBy: number;
    actionOn: number;
    approverComments: string;
}

export class ReqSaveKYCDocumentDetail {
    userKYCFormMappingId: number;
    userID: number;
    formID: number;
    hasReceipt: boolean;
    submissionDate: number;
    saveAndSubmit: number;
    lstVendorKYCDocumentFieldDetails: VendorKYCDocumentFieldDetails[];
}

export class KYCDocumentDetails {
    documentId: number;
    formID: number;
    formFieldID: number;
    documentName: string;
    documentUrl: string;
    documentDate: number;
    documentType: number;
    documentSize: number;
}

export class RespVendorDashboardDetails {
    dashboardData: DashboardData;
    vendorSummary: VendorSummary;
    lstTop10Vendors: Top10Vendors[];
    lstTop10Categories: Top10Categories[];
    lstTop10Outstanding: Top10Outstanding[];
    lstTop10Approvers: Top10Approvers[];
    lstDashboardInvoiceGraphDetails: DashboardInvoiceGraphDetails[];
}

export class DashboardData {
    totalVendor: number;
    activeVendors: number;
    inactiveVendors: number;
    totalPayment: number;
    maxPayment: number;
    minPayment: number;
    totalAmountDue: number;
    lastMonthDue: number;
    currentMonthDue: number;
    kycCompleted: number;
    incompleteKYC: number;
    pendingKYC: number;
}

export class VendorDetails {
    vendorId: number;
    vendorName: string;
    totalInvoice: number;
    outstandingInvoices: number;
}

export class VendorInvoiceDetails {
    vendorId: number;
    invoiceId: number;
    dateOfInvoice: number;
    dueDate: number;
    expenseAmount: number;
    paidAmount: number;
    outstandingBalance: number;
}

export class VendorSummary {
    lstVendorDetails: VendorDetails[];
    lstVendorInvoiceDetails: VendorInvoiceDetails[];
}

export class Top10Vendors {
    vendorId: number;
    vendorName: string;
    purchaseAmount: number;
}

export class Top10Categories {
    expenseCategoryId: number;
    expenseCategoryName: string;
    purchaseAmount: number;
}

export class Top10Outstanding {
    vendorId: number;
    vendorName: string;
    outstandingAmount: number;
}

export class Top10Approvers {
    ApproverId: number;
    ApproverName: string;
    InvoiceAmount: number;
}

export class DashboardInvoiceGraphDetails {
    orgId: number;
    invoicePaid: number;
    invoiceRaised: number;
    month: number;
    monthName: string;
}

export class SelectVendorCategoriesInputModel {
    assignedCategoryIdsList: VendorCategoriesApproverModel[];
}
export class SelectVendorCategoriesOutputModel {
    assignedCategoriesName: string;
    assignedCategoryIdsList: VendorCategoriesApproverModel[];
}
export class VendorCategoriesApproverModel {
    categoryId: number;
}
export class VendorListResponse {
    userId: number;
    displayName: string;
    email: string;
    employeeCode: string;
    status: number;
    kycStatus: number;
    selected: boolean;
    hideDeactivate: boolean;
    disableDeactivate: boolean;
    hideActivate: boolean;
    hideSendInvite: boolean;
    hideResendInvite: boolean;
    employeeCode2: string;
    employeeCode3: string;
    employeeCode4: string;
    firstName: string;
    lastName: string;
    category: string;
    approver: string;
    contactName: string;
    assignedCategories: string[];
    assignedBrands: string[];
}
export class VendorFormModel {
    employeeId: number;
    employeeFirstName: string;
    employeeLastName: string;
    employeeEmail: string;
    employeeCode: string;
    employeeCode2: string;
    employeeCode3: string;
    employeeCode4: string;
    derivedName: string;
    employeeStatus: number;
    employeeStatusToggle: boolean;
    loginUserId: number;
    isFmOnly: boolean;
    assignedExpCatIds: string;
    assignedFormIds: string;
    assignedExpenseCategories: number[];
    assignedForms: number[];
    assignedCategories: VendorCategoriesApproverModel[];
    companyName: string;
    contactName: string;
    address: string;
}
export interface IAddUpdateVendorRequestDto {
    employeeID: number;
    employeeCode: string;
    employeeCode2: string;
    employeeCode3: string;
    employeeCode4: string;
    firstName: string;
    lastName: string;
    email: string;
    status: number;
    derivedName: string;
    userType: number;
    assignedExpCatIds: string;
    assignedFormIds: string;
}

export class AddUpdateVendorRequestDto implements IAddUpdateVendorRequestDto {
    constructor(
        public employeeID: number,
        public employeeCode: string,
        public employeeCode2: string,
        public employeeCode3: string,
        public employeeCode4: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public status: number,
        public isPasswordReset: boolean,
        public derivedName: string,
        public userType: number,
        public assignedExpCatIds: string,
        public assignedFormIds: string,
        public customFields: VendorCustomFields[],
        public assignedCategories: VendorCategoriesApproverModel[],
        public companyName: string,
        public contactName: string,
        public address: string,
        public assignedBrands: VendorBrandModel[],
    ) {
    }
}
export interface IAddUpdateBulkVendorRequestDto {
    fmEmail: string;
    fmName: string;
    fmUserId: number;
    employees: IAddUpdateVendorRequestDto[]
    isImport: boolean;
}

export class AddUpdateBulkVendorRequestDto implements IAddUpdateBulkVendorRequestDto {
    constructor(public fmEmail: string, public fmName: string, public fmUserId: number,
        public employees: AddUpdateVendorRequestDto[], public isImport: boolean) {

    }
}
export interface IVendorCustomFields {
    UserKYCFormFieldDetailsID: number;
    UserId: number;
    OrgId: number;
    FormFieldID: number;
    FormID: number;
    FormFieldValue: string;
}
export class VendorCustomFields implements IVendorCustomFields {
    constructor(public UserKYCFormFieldDetailsID: number,
        public UserId: number,
        public OrgId: number,
        public FormFieldID: number,
        public FormID: number,
        public FormFieldValue: string) { }
}
export class GetPoDisplayRequest {
    public orgId: number;
    public userId: number;
}
export class poDisplay {
    public poDisplayID: number;
    public formFieldType: number;
    public setupValue: string;
    public active: boolean;
    public formID: number;
    public formFieldID: number;
    public orgId: number;
    public setupName: string;
}
export class PoDisplayResponse {
    public orgId: number;
    public userId: number;
    public employeeCode: string;
    public employeeCode2: string;
    public expenseCategoryName: string;
    public poDisplayList: poDisplay[];
}
export class SavePoDisplayRequest {
    public orgId: number;
    public userId: number;
    public poDisplayList: poDisplay[];
}
export class PoTemplateProperties {
    poTemplatePropId: number;
    sectionEnum: number;
    fieldType: number;
    setupValue: string;
    active: boolean;
    poId: number;
    orgId: number;
    templateNumber: number;
    PoTemplateId: number;
}
export class PoTemplatePropertiesResponse {
    public orgId: number;
    public userId: number;
    public poTemplateProperties: PoTemplateProperties[];
    public respForms: RespForms;
    public selectedTemplateNumber: number;
}
export class SavePoTemplatePropertiesRequest {
    public orgId: number;
    public userId: number;
    public poTemplateProperties: PoTemplateProperties[];
    public respForms: RespForms;
    public selectedTemplateNumber: number;
}
export class GetPoTemplatePropertiesRequest {
    public orgId: number;
    public userId: number;
}
export class GetFormRequest {
    formType: number;
    orgId: number;
    action: number;
}

export class RequisitionUserList {
    public userId: number;
    public displayName: string;
    public email: string;
    public orgRoleId: string;
    public requisitionType: string;
}
export class GetRequisitionUserListResponse {

    public requisitionUserLists: RequisitionUserList[];
}
export class GetRequisitionUserListRequest {
    userId: number;
    orgId: number;
    action: number;
}
export class UpdateForRequisitionRequest {
    userId: number;
    orgId: number;
    action: number;
    userIds: number[];
    requisitionAcessType: number;

    //log fields
    oldRequisitionAcessType: number;
}
export class UpdateForRequisitionResponse {
    result: boolean;

}
export class UserKYCFormFieldDetailRequest {
    customFields: VendorCustomFields[]
}
export class UserKYCFormFieldDetailResponse {
    result: any;

}
export class GetFormFieldDetailRequest {
    orgId: number;
    userId: number;
    formType: number;
}

export class ItemGradeList {
    public categoryItemId: number;
    public gradeId: number;
    public gradeName: string;
}
export class ItemAssignedGrade {
    public categoryItemId: number;
    public categoryItemName: string;
    public expenseCategoryName: string;
    public brandName: string;
    public gradeName: string;
    public gradeCount: number;
    public itemGradeList: ItemGradeList[];
}
export class GetGradeMappingRequest {
    public orgId: number;
    public Action: number;
}
export class RespGetItemGradeMapping {
    public itemAssignedGradeList: ItemAssignedGrade[];
}

export class CategoryItem {
    public categoryItemId: number;
    public orgExpenseCategoryId: number;
    public organisationId: number;
    public name: string;
    public code: string;
    public detail: string;
    public isActive: boolean;
    public createdBy: number;
    public createdOn: number;
    public isVisible: boolean;
    public isImported: boolean;
    public type: number;
    public itemBrandId: number;
    public receiptsInfo: IReceiptInfo[];
}
export class RequestSaveCategoriesAndItemsData {
    categoryItems: CategoryItem[];
    orgId: number;
    action: number;
    userId: number;
    categoryItemId: number;
}
export class RequestImportVendorGrades {
    orgId: number;
    userId: number;
    action: number;
}

export class GetVendorListRequest {
    OrgId: number;
    Type: number;
    action: number;
    userId: number;
    id: number;

}

export class GetOrderListRequest {
    orgId: number;
    userId: number;
    id: number;
    orgExpenseCategoryId: number;
    orderDetailId: number;
    action: number;
    requisitionApprovalRuleType: number;

}
export class OrderDetail {
    orderDetailId: number;
    categoryItemId: number;
    quantity: number;
    unitPrice: number;
    amount: number;
    mobileExpenseUniqueId?: string;
    userId: number;
    orgId: number;
    orgExpenseCategoryId: number;
    baseCategoryId: number;
    date: number;
    platformId: number;
    currentStatus: number;
    hasReceipt: boolean;
    notes?: string;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
    costCentreId: number;
    isPolicyViolated: boolean;
    submissionDate: number;
    ipAddress?: string;
    claimType: number;
    deliAddUpdatePOandMappingReqveredQuantity: number;
    purchaseOrderCategoryItemMappingId: number;
    purchaseOrderId: number;
}



export class RespGetOrderData {
    orgId: number;
    userId: number;
    id: number;
    count: number;
    itemList: ItemList[]
    claimantListForApprover: any[];
}

export class GetCategoryListResponse {
    vendorCategoryList: VendorCategoryList[]
}
export class VendorCategoryList {
    orgExpenseCategoryId: number;
    vendorCategoryName: string;
    vendorCategoryItemList: VendorCategoryItemList[];
}


export class GradeModel {
    Id: number;
    Value: string;
    IsActive: boolean;

}

export class UserGradeMapping {
    UserGradeMappingId: number;
    UserId: number;
    OrgId: number;
    GradeId: number;
    CreatedBy: number;
    CreatedOn: number;
    UpdatedBy: number;
    UpdatedOn: number;
    GradeName: string;
    ClaimantName: string;
}
export class ApproverGradeMapping {
    ApproverGradeMappingId: number;
    UserId: number;
    OrgId: number;
    GradeId: number;
    CreatedBy: number;
    CreatedOn: number;
    UpdatedBy: number;
    UpdatedOn: number;
    GradeName: string;
    ApproverName: string;

}

export class GradeMappringResponse {
    orgId: number;
    action: number;
    gradeModel: GradeModel[];
    userGradeMappingList: UserGradeMapping[];
    approverGradeMappingList: ApproverGradeMapping[];

}

export class RespGradeAssignUnassignToItem {
    result: string;
}

export class VendorCategoryItemList {
    categoryItemId: number;
    vendorCategoryItemName: string;
    orgExpenseCategoryId: number;
    receiptInfo: IReceiptInfo[];
}

export class SaveOrderDetailReq {
    orgId: number;
    userId: number;
    action: number;
    orderDetailList: OrderDetail[]
}
export class SaveOrderDetailResponse {
    result: any;
}
export class ApproveRejectRequisitionRequest {
    action: number;
    notes: string;
    orgId: number;
    userId: number;
    userName: string;
    isFinanceApproverAction: boolean = false;
    requestTimeStamp: number;
    requisitionIds: number[];
}
export class OrderJustificationNotes {
    reqJustNotesId: number;
    justificationNotes: string;
    actionString: string;
    orderDetailId?: number;
    createdBy?: number;
    createdOn?: number;
}

export class PurchaseOrder {
    purchaseOrderId: number = 0;
    userId: number = 0;
    orgId: number = 0;
    date: number = 0;
    platformId: number = 0;
    currentStatus: number = 0;
    notes: string = "";
    createdBy: number = 0;
    createdOn: number = 0;
    updatedBy: number = 0;
    updatedOn: number = 0;
    submissionDate: number = 0;
    purchaseOrderSequence: number;
    purchaseOrderNumber: string;
}

export class PurchaseOrderItemMapping {
    purchaseOrderItemMappingId: number = 0;
    purchaseOrderId: number = 0;
    orderDetailId: number = 0;
    orgId: number = 0;
    createdBy: number = 0;
    createdOn: number = 0;
    unitPrice: number = 0;
}
export class PurchaseOrderCategoryItemMapping {
    purchaseOrderCategoryItemMappingId: number = 0;
    purchaseOrderId: number = 0;
    categoryItemId: number = 0;
    orgId: number = 0;
    createdBy: number = 0;
    createdOn: number = 0;
    unitPrice: number = 0;
}

export class AddUpdatePOandMappingReq {
    purchaseOrderId: number = 0;
    orgId: number = 0;
    userId: number = 0;
    action: number = 0;
    notes: string = "";
    purchaseOrderSequence: number = 0;
    purchaseOrderNumber: string;   //AddUpdateMappingEnum
    purchaseOrders: PurchaseOrder[];   //Add userId in this object plus orgid and other thing present 
    purchaseOrderItemMappings: PurchaseOrderItemMapping[];
    purchaseOrderCategoryItemMappings: PurchaseOrderCategoryItemMapping[];
}
export class AddUpdatePOandMappingResp {
    result: any;
}
export class GetPOandMappingDataReq {
    purchaseOrderId: number;
    orgId: number;
    action: number;
}
export class ItemList extends OrderDetail {
    name: string;                // Corresponds to 'Name' in C#
    vendorCategoryName: string; // Corresponds to 'VendorCategoryName' in C#
    vendorCategoryItemName: string; // Corresponds to 'VendorCategoryItemName' in C#
    vendorName: string;
    employeeName: string;
    costCentreName: string;
    email: string;
    receiptInfo: IReceiptInfo[];
    approverNotes: IApproverNotes[];
    approverName: string;
}

export class PurchaseOrderAndMapping extends PurchaseOrder {
    totalItemCount: number;
    totalQuantity: number;
    totalAmount: number;
    vendorId: number;
    receiptsInfo: ReceiptsInfo[];
    purchaseOrderAndItemsList: PurchaseOrderAndItems[];
    vendorCategoryName: string;
    vendorName: string;
    approverNotes: IApproverNotes[];
}
export class PurchaseOrderAndItems extends ItemList {

    itemLists: ItemList[];
}

export class GetPOandMappingDataResp {
    purchaseOrderAndMappings: PurchaseOrderAndMapping[];
}
export class GetPoPreviewRequest {
    orgId: number;
    vendorId: number;
    purchaseOrderId: number;
}

export class PoReceiptSaveRequest {
    purchaseOrderIds: any[];
    receiptsInfo: ReceiptsInfo[];
}
export class SavePoRequest {
    poReceiptSaveRequest: PoReceiptSaveRequest;
    addUpdatePOandMappingReq: AddUpdatePOandMappingReq;
}

export class PoExportRequest {
    poHtml: string;
    footerHtml: string;
    orgId: number;
    action: number;
    purchaseOrderId: number;
    isFooterEnabled: boolean;
}
export interface ItemBrand {
    itemBrandId: number;
    orgId: number;
    brandName: string;
    brandDescription: string;
    brandStatus: number;
    isImported: boolean;
}

export interface IGetAndSaveItemBrandsReqResp {
    orgId: number;
    result: string;
    action: number;
    itemBrandId: number;
    itemBrands: ItemBrand[];
}


export interface GetAndSaveItemBrandsReqResp {
    orgId: number;
    result: string;
    action: number;
    itemBrandId: number;
    itemBrands: ItemBrand[];
}
export class VendorBrandModel {
    itemBrandId: number;
}
export class SelectVendorBrandInputModel {
    assignedIdsList: VendorBrandModel[];
}
export class SelectVendorBrandOutputModel {
    assignedName: string;
    assignedIdsList: VendorBrandModel[];
}

export class ItemBrand implements ItemBrand {
    itemBrandId: number;
    orgId: number;
    brandName: string;
    brandDescription: string;
    brandStatus: number;
    isImported: boolean;
    isActive: boolean;
    oldIsActive: boolean;
    oldBrandDescription: string;
    oldBrandName: string;

}

export class GetAndSaveItemBrandsReqResp implements IGetAndSaveItemBrandsReqResp {
    orgId: number;
    result: string;
    action: number;
    itemBrandId: number;
    itemBrands: ItemBrand[];
}

export class ItemGradeMapping {
    itemGradeMappingId: number;
    categoryItemId: number;
    orgId: number;
    gradeId: number;
    gradeName: string;
    categoryItemName: string;
}

export class SaveItemGradeMappingRequest {
    orgId: number;
    userId: number;
    action: number;
    itemGradeMappingList: ItemGradeMapping[];
}

export class VendorDashboardDataRequest {
    orgId: number;
    userId: number;
    requestCountType: number;
    loginId: string;
    requisitionApprovalRuleType: number;
}

export class GetInvoiceDataReq {
    invoiceId: number;
    orgId: number;
    userId: number;
    action: number;
}

export class GetInvoiceDataResp {
    invoiceList: InvoiceDetails[];
}

export class VendorInvoice {
    invoiceId: number;
    purchaseOrderId: number;
    mobileExpenseUniqueId: string;
    userId: number;
    orgId: number;
    invoiceDate: number;
    invoiceDueDate: number;
    platformId: number;
    currentStatus: number;
    hasReceipt: boolean;
    notes: string;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
    isPolicyViolated: boolean;
    submissionDate: number;
    ipAddress: string;
    amount: string;
    totalQuantity: string;
    invoiceNumber: string;
    receiptsInfo: InvoiceReceipt[] = [];
    exportId: number;
    exportedOn: number;

}
export class InvoiceDetails extends VendorInvoice {

    category: string;
    purchaseOrderNumber: string;
}

export class InvoiceReceipt {
    receiptId: number;
    invoiceId: number;
    receiptPath: string;
    receiptType: number = 0;
    lat: string;
    long: string;
    isDeletable: boolean = false;
    receiptName: string;
    receiptDate: number = 0;
    receiptLocationName: string;
    receiptFormatId: number = 0;
    isEmailedReceipt: boolean = false;
    receiptSize: number = 0;
    rotationDegree: number = 0;
    receiptScanOption: number = 0;
}

export class GetReportPODetailsReq {
    orgId: number;
}

export class GetReportPODetailsResp {
    vendorReportDetailsList: VendorReportList[];
}

export class VendorReportList {
    userId: number;
    totalAmountOfPOs: number;
    totalAmountSpent: number;
    amountNotBilled: number;
    amountBilled: number;
    vendorName: string;
    reportPOdetails: ReportPOdetails[];
}

export class ReportPOdetails {
    poAmount: number;
    userId: number;
    amountSpent: number;
    amountNotPaid: number;
    orgExpenseCategoryId: number;
    expenseCategoryName: string;
    purchaseOrderNumber: string;
    purchaseOrderId: number;
    poPassbooks: POPassbook[];
}

export class POPassbook {

    passbookId: number;
    purchaseOrderId: number;
    invoiceId: number;
    date: number;
    pONumber: string;
    category: string;
    approver: string;
    pOValue: number;
    pOAmountSpent: number;
    pOBalance: number;
    pOQuantity: number;
    pOQtyDelivered: number;
    pOQtyBalance: number;
    amtOwned: number;
    amtPFP: number;
    balance: number;
    docText: string;
}
export class SelectPurchaseOrderModel {
    purchaseOrderId: number;
    purchaseOrderNumber: string;
}
export class RequestSaveInvoice {
    vendorInvoices: VendorInvoice[];
    receipts: InvoiceReceipt[];
    orgId: number;
    action: number;
    userId: number;
    invoiceId: number;
    purchaseOrderAndItemsList: PurchaseOrderAndItems[];
}

export class GetVendorInvoiceListReq {
    orgId: number;
    userId: number;
    action: number;
}

export class GetVendorInvoiceListResp {
    vendorInvoiceList: VendorInvoiceCreated[];
}

export class VendorInvoiceCreated {
    userId: number;
    vendorName: string;
    vendorPoList: VendorPo[];
    totalCount: number;
    totalValue: number;
}

export class VendorPo {
    userId: number;
    purchaseOrderNumber: string;
    purchaseOrderId: number;
    invoiceList: InvoiceDetailsCreated[];
    totalCount: number;
    totalValue: number;
}

export class InvoiceDetailsCreated {
    invoiceDate: number;
    quantity: number;
    creditAmount: number;
    debitAmount: number;
    balance: number;
    purchaseOrderId: number;
    invoiceDescription: string;
    invoiceNumber: string;
    invoiceAmount: number;
    invoiceDueDate: number;
    invoiceId: any;
    receiptsInfo: IReceiptInfo[];

}

export class SubmitInvoiceActionRequest {
    orgId: number;
    userId: number;
    action: number;
    invoiceId: number[];
    notes: string;
    isFinanceApproverAction: boolean = false;
}

export class SubmitInvoiceActionResponse {
    result: boolean;
}
export class GetPoItemsPassbookRequest {
    poId: number;
    orgId: number;
    action: number;
    itemId: number;
}
export class OrderAllocation {
    orderAllocationId: number;
    purchaseOrderId: number;
    categoryItemId: number;
    invoiceId: number;
    orderDetailId: number;
    orgId: number;
    createdBy: number;
    createdOn: number;
    allocatedQuantity: number;
    newAllocatedQuantity: number;
    claimantId: number;
}

export class AddUpdateOrderAllocationRequest {
    totalQuantity: number;
    orderAllocations: OrderAllocation[];
}
export class GetItemOrderAllocationRequest {
    public orgId: number;
    public purchaseOrderId: number;
    public invoiceId: number;
    public categoryItemId: number;
}
export class InvoicePoMappingGrid {
    public categoryItemId: number;
    public name: string;
    public quantity: number;
    public unitPrice: number;
    public amount: number;
    public deliveredQuantity: string;
}

export class ReqGetVendorDashboard {
    dateRangeType: string;
    startDate: number;
    endDate: number;
}

export class GetVendorDashboardDetailsResponse {
    totalNumberOfPOs: number;
    pendingPOs: number;
    pendingInvoices: number;
    totalValueOfAllPOs: number;
    totalPaymentsMade: number;
    totalValueOfAllInvoicesRaised: number;
    largestPayment: number;
    smallestPayment: number;
    paidInvoices: number;
    unpaidInvoices: number;
    outstandingAmount: number;
    partiallyAllocatedInvoiceCount: number;
    unallocatedInvoiceCount: number;
    dashboardInvoiceSpentGraphDetails: DashboardInvoiceSpentGraphDetails[];
}
export class DashboardInvoiceSpentGraphDetails {
    orgId: number;
    spentAmount: number;
    outstandingAmount: number;
    monthNumber: number;
    monthName: string;
}
export class GetDashboardReportRequest {
    vendorId: number;
    purchaseOrderId: number;
    orgExpenseCategoryId: number;
    action: number;
    orgId: number;
}
export class VendorReportCommonDetails {
    amountNotBilled: number;
    amountBilled: number;
    amountNotPaid: number;
    amountPaid: number;
    totalAmountOfPOs: number; // Value Of All POS
}

export class VendorReportAllVendors extends VendorReportCommonDetails {
    vendorName: string; // Vendor Name
    noOfPos: number; // No. of Pos.
    noOfCategories: number; // Categories
    vendorId: number;
    reportPOdetails: ReportPOdetails[];
}

export class VendorReportAllCategories extends VendorReportCommonDetails {
    categoryName: string; // Category Name
    noOfVendors: number; // No. of Vendors
    noOfPos: number; // No. of Pos.
    orgExpenseCategoryId: number; // OrgExpenseCategoryId
}

export class VendorReportAllPurchaseOrders extends VendorReportCommonDetails {
    vendorName: string; // Vendor Name
    purchaseOrderNumber: string; // PurchaseOrderNumber
    noOfCategories: number; // Categories
    purchaseOrderId: number; // PurchaseOrderId
    vendorId: number; // VendorId
}

export class GetDashboardReportResponse {
    vendorReportAllVendors: VendorReportAllVendors[];
    vendorReportAllCategories: VendorReportAllCategories[];
    vendorReportAllPurchaseOrders: VendorReportAllPurchaseOrders[];
}









